export default [
    {
        path: '/sistema/cliente/',
        name: 'home-client',
        component: () => import('@/views/cliente/index/Index.vue'),
        meta: {
            pageTitle: 'Página Inicial',
            resource: 'any',
            breadcrumb: [
                {
                    text: 'Página Inicial',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/sistema/cliente/agendamento',
        name: 'agendamento',
        component: () => import('@/views/cliente/agendamento/Index.vue'),
        meta: {
            pageTitle: 'Agendamento',
            contentClass: 'ecommerce-application',
            resource: 'any',
            navActiveLink: 'agendamento',
            breadcrumb: [
                {
                    text: 'Agendamento',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/sistema/cliente/agendamento/detalhe/:cpfcnpj/:app?',
        name: 'agendamentoDetalhe',
        component: () => import('@/views/cliente/agendamento/Detalhe.vue'),
        meta: {
            pageTitle: 'Agendamento Detalhe',
            contentClass: 'ecommerce-application',
            resource: 'auth',
            navActiveLink: 'agendamento',
            breadcrumb: [
                {
                    text: 'Agendamento',
                    active: true,
                },
                {
                    text: 'Detalhe',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/sistema/cliente/agendamento/detalhe/:cpfcnpj/checklist/:id?',
        name: 'agendamentoDetalheChecklist',
        component: () => import('@/views/cliente/ChecklistPublic.vue'),
        meta: {
            pageTitle: 'Checklist de Veículo',
            contentClass: 'ecommerce-application',
            resource: 'auth',
            navActiveLink: 'agendamento',
            publicPage: true,
            breadcrumb: [
                {
                    text: 'Agendamento',
                    active: true,
                },
                {
                    text: 'Checklist',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/sistema/cliente/orcamento/:cpfcnpj/checklist/:id?',
        name: 'orcamentoChecklist',
        component: () => import('@/views/cliente/ChecklistPublic.vue'),
        meta: {
            pageTitle: 'Checklist de Entrada',
            contentClass: 'ecommerce-application',
            resource: 'auth',
            navActiveLink: 'agendamento',
            publicPage: true,
            tipoChecklist: 'entrada',
            breadcrumb: [
                {
                    text: 'Orçamento',
                    active: true,
                },
                {
                    text: 'Checklist',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/sistema/cliente/configuracoes/:step?',
        name: 'configuracoes-client',
        component: () => import('@/views/cliente/configuracoes/Index.vue'),
        meta: {
            pageTitle: 'Configurações',
            resource: 'any',
            navActiveLink: 'configuracoes',
            breadcrumb: [
                {
                    text: 'Configurações',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/sistema/cliente/cadastro',
        name: 'cadastro',
        component: () => import('@/views/cliente/cadastro/Cadastro.vue'),
        meta: {
            pageTitle: 'Cadastrar',
            resource: 'auth',
            layout: 'full',
        },
    },
    {
        // Idem `login-company`. O componente de formulário do cliente
        // continua existindo — é ele que a sidebar do auto-agendamento usa —,
        // mas esta ROTA passa a levar ao login único.
        path: '/sistema/cliente/login',
        name: 'login-client',
        component: () => import('@/views/auth/RedirecionarParaLoginGeral.vue'),
        meta: {
            pageTitle: 'Acessar Sistema',
            resource: 'auth',
            layout: 'full',
        },
    },
    {
        path: '/sistema/cliente/esqueciminhasenha',
        name: 'esqueciminhasenha-client',
        component: () => import('@/views/cliente/ForgotPassword.vue'),
        meta: {
            resource: 'auth',
            layout: 'full',
        },
    },
    {
        path: '/sistema/cliente/nao-autorizado',
        name: 'naoAutorizado-client',
        component: () => import('@/views/cliente/naoAutorizado/Index.vue'),
        meta: {
            layout: 'full',
            resource: 'any'
        }
    },
]
